import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export const useTagsOuvidoriaNavegacao = () => {
  const history = useHistory();

  const handleRowClick = useCallback(
    row => {
      history.push(`/pages/tagsouvidoria/${row.id}`);
    },
    [history]
  );

  const handleAdicionar = useCallback(() => {
    history.push('/pages/tagsouvidoria/criar');
  }, [history]);

  const handleEditar = useCallback(
    id => {
      history.push(`/pages/tagsouvidoria/editar/${id}`);
    },
    [history]
  );

  return {
    handleRowClick,
    handleAdicionar,
    handleEditar,
  };
};
